<template>
  <div class="flex_vertial">
    <img class="icon" src="../../assets/irobot3.png">
    <div class="head_title">开通成功</div>
    <div class="head_title_gray">你已获得3次使用机会</div>
    <div style="flex:4;"></div>
    <div class="open_button" @click="buyvip">购买会员无限次使用</div>
    <div class="open_button_white" @click="finishBind">免费试用三次</div>
  </div>
</template>

<script>

import jsbridge from '@/jsbridge'
import util from '@/utils/util'
import lubanApi from '@/lubanApi'
import app from '@/AppData'

const TAG = '[BindSuccess]'

export default {
  inject: ['reload'],
  name: 'bindGuidePage',
  data () {
    return {}
  },
  methods: {
    // 使用3次后，跳转首页
    finishBind () {
      this.gotoHome()
    },

    buyvip () {
      jsbridge.openVip(this)
      lubanApi.reportseer('AICall_Open_Success_InviteOpenVip_ClickVip')
    },

    gotoHome () {
      util.Toast('恭喜你已开通成功', 5000)
      this.$router.replace({
        path: '/'
      })
    }
  },

  activated () {
    lubanApi.reportseer('AICall_Open_Success_InviteOpenVip_Show')
    // 检查是否Vip，如果是则直接跳转首页
    var that = this
    app.getVipInfoWithLimit(true).then(res => {
      console.log(TAG, 'getVipInfoWithLimit', res)
      if (res.vipStatus == 1) {
        that.gotoHome()
      }
    })
  }
}
</script>

<style scoped lang="less" src="@/styles/common.less"/>
<style scoped>
.icon {
  width: 11rem;
  height: 11rem;
  margin-bottom: -2rem;
  margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/bind/BindSuccess.vue